import { FulfillmentGroupDataSchema } from "@redotech/redo-fulfillment-group-common/fulfillment-group";
import * as zExt from "@redotech/rpc/ext";
import * as z from "zod";

export const getLatestOpenFulfillmentGroup = {
  name: "getLatestOpenFulfillmentGroup" as const,
  input: z.object({
    fulfillmentGroupId: z.string(),
    requestSource: z.literal("scan").nullish(),
    scannedToteId: zExt.objectId().nullish(),
  }),
  output: z.object({
    fulfillmentGroup: FulfillmentGroupDataSchema,
    originalGroupWasMerged: z.boolean().nullish(),
  }),
};
